var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fbb03b;}")),React.createElement("path",{"className":"a","d":"M38.26,11.251a1.781,1.781,0,0,0-.828,2.379A17.635,17.635,0,0,1,39.2,21.379,17.816,17.816,0,1,1,21.379,3.563,17.6,17.6,0,0,1,32.44,7.407a1.781,1.781,0,1,0,2.217-2.789,21.382,21.382,0,1,0,8.1,16.761,21.161,21.161,0,0,0-2.12-9.3A1.78,1.78,0,0,0,38.26,11.251Zm0,0","key":1}),React.createElement("path",{"className":"a","d":"M177.782,64A1.782,1.782,0,0,0,176,65.782V78.253a1.782,1.782,0,0,0,1.782,1.782h8.908a1.782,1.782,0,0,0,0-3.563h-7.126V65.782A1.782,1.782,0,0,0,177.782,64Zm0,0","transform":"translate(-156.402 -56.874)","key":2})]);
}

Clock.defaultProps = {"width":"42.759","height":"42.759","viewBox":"0 0 42.759 42.759"};

module.exports = Clock;

Clock.default = Clock;
